var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8068_58856)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9562 8.87757C9.90607 9.13638 9.65633 9.30656 9.3968 9.25807C9.13622 9.20938 8.96444 8.95866 9.01314 8.69807L9.48497 8.78624C9.01314 8.69807 9.01319 8.6978 9.01324 8.69752L9.01335 8.69692L9.0136 8.6956L9.01421 8.69245L9.01589 8.68412C9.01722 8.67768 9.01897 8.66949 9.0212 8.65966C9.02565 8.64001 9.03202 8.61375 9.0407 8.58181C9.05805 8.51804 9.08482 8.43097 9.12439 8.32835C9.20313 8.12416 9.33507 7.85174 9.54959 7.57817C9.99124 7.01495 10.7563 6.48426 12.0022 6.48999C13.3192 6.49605 14.2036 7.31962 14.5744 8.28637C14.9351 9.2269 14.8428 10.3989 14.1052 11.1498C13.5901 11.6762 13.1491 12.1097 12.8361 12.4139C12.7235 12.5256 12.634 12.6584 12.5729 12.8048C12.5115 12.9518 12.48 13.1095 12.48 13.2687V14.235C12.48 14.5001 12.2651 14.715 12 14.715C11.7349 14.715 11.52 14.5001 11.52 14.235V13.2688C11.52 13.2688 11.52 13.2688 11.52 13.2688C11.52 12.9825 11.5767 12.6991 11.687 12.4349C11.7973 12.1708 11.9589 11.9311 12.1625 11.7299L12.1654 11.727C12.4748 11.4264 12.9105 10.9981 13.4194 10.478L13.4201 10.4773C13.8284 10.0619 13.9416 9.31729 13.6781 8.63017C13.4245 7.9691 12.8545 7.45392 11.9978 7.44998C11.0699 7.44571 10.5774 7.82315 10.305 8.17055C10.1625 8.35229 10.0733 8.53581 10.0201 8.67373C9.99373 8.74216 9.97686 8.79769 9.96705 8.83376C9.96216 8.85174 9.95907 8.8647 9.95747 8.8718C9.95678 8.87483 9.95637 8.87677 9.9562 8.87757Z",
    fill: "url(#paint0_radial_8068_58856)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 2.98C7.01792 2.98 2.97953 7.01839 2.97953 12C2.97953 16.9816 7.01792 21.02 11.9995 21.02C16.9811 21.02 21.0195 16.9816 21.0195 12C21.0195 7.01839 16.9811 2.98 11.9995 2.98ZM2.01953 12C2.01953 6.48819 6.48773 2.02 11.9995 2.02C17.5113 2.02 21.9795 6.48819 21.9795 12C21.9795 17.5118 17.5113 21.98 11.9995 21.98C6.48773 21.98 2.01953 17.5118 2.01953 12Z",
    fill: "url(#paint1_radial_8068_58856)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 17.23C12.1266 17.23 12.2295 17.127 12.2295 17C12.2295 16.873 12.1266 16.77 11.9995 16.77C11.8725 16.77 11.7695 16.873 11.7695 17C11.7695 17.127 11.8725 17.23 11.9995 17.23ZM11.2695 17C11.2695 16.5968 11.5964 16.27 11.9995 16.27C12.4027 16.27 12.7295 16.5968 12.7295 17C12.7295 17.4032 12.4027 17.73 11.9995 17.73C11.5964 17.73 11.2695 17.4032 11.2695 17Z",
    fill: "url(#paint2_radial_8068_58856)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 17.355C12.1956 17.355 12.3545 17.1961 12.3545 17C12.3545 16.8039 12.1956 16.645 11.9995 16.645C11.8035 16.645 11.6445 16.8039 11.6445 17C11.6445 17.1961 11.8035 17.355 11.9995 17.355ZM11.3945 17C11.3945 16.6659 11.6654 16.395 11.9995 16.395C12.3337 16.395 12.6045 16.6659 12.6045 17C12.6045 17.3341 12.3337 17.605 11.9995 17.605C11.6654 17.605 11.3945 17.3341 11.3945 17Z",
    fill: "url(#paint3_radial_8068_58856)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17C12.75 16.5858 12.4142 16.25 12 16.25C11.5858 16.25 11.25 16.5858 11.25 17C11.25 17.4142 11.5858 17.75 12 17.75Z",
    fill: "url(#paint4_radial_8068_58856)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8068_58856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2283 16.8699) rotate(-124.95) scale(14.7311 47.0604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8068_58856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9895 27.2095) rotate(-134.873) scale(41.3466 140.653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8068_58856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.096 18.1125) rotate(-134.873) scale(3.02435 10.2882)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_8068_58856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9082 17.922) rotate(-134.873) scale(2.50649 8.52653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_8068_58856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1265 18.143) rotate(-134.873) scale(3.10721 10.5701)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8068_58856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.a1b3ff42f3f94fee02c1deed47eb0c00.svg";
export { ForwardRef as ReactComponent };